import classNames from 'classnames';
import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Badge = ({ children, className, onClick }: BadgeProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'text-nowrap text-[14px] px-2 flex items-center justify-center overflow-hidden',
        {
          'rounded-full': !className?.includes('rounded-'),
          'bg-gray-200': !className?.includes('bg-'),
          'py-1': !className?.includes('py-'),
          'text-gray-600': !className?.includes('text-'),
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
